import axiosInstance from "./baseUrl";

// Fetch all KYC records
export const fetchAllKycService = async (params: any) => {
  const response = await axiosInstance.get("/v1/kyc/all", { params });
  return response.data;
};

// Fetch single KYC record by ID
export const fetchSingleKycService = async (id: string) => {
  const response = await axiosInstance.get("/v1/kyc/single", {
    params: { id },
  });
  return response.data;
};

// Approve a KYC record by ID
export const approveKycService = async (params: {
  userId: string;
  status: string;
  verified: boolean;
}) => {
  const response = await axiosInstance.post("/v1/kyc/verify-kyc", {}, {
    params,
  });
  return response.data;
};

// Reject a KYC record by ID
export const rejectKycService = async (params: {
  userId: string;
  status: string;
  verified: boolean;
}) => {
  const response = await axiosInstance.post("/v1/kyc/verify-kyc", {}, {
    params,
  });
  return response.data;
};
